import { 
    GET_CAT_POLICY, 
    GET_CAT_POLICY_ID, 
    GET_UNKER, 
    GET_UNKER_ID, 
    GET_POLICY_SEARCH, 
    GET_COUNTER_DOWNLOAD_POLICY, 
    GET_COUNTER_VIEW_POLICY 
} from "shared/constants/ActionTypes";

const initialState = {
    dataCategoryPolicy: null,
    dataCategoryPolicyId: null,
    dataUnker:null,
    dataUnkerId: null,
    dataPolicySearch:null,
    counterDownload:null,
    counterView:null
};

const getCategoryPolicyReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_CAT_POLICY:
            return {
                ...state,
                dataCategoryPolicy:action.payload
            }
        case GET_CAT_POLICY_ID:
            return {
                ...state,
                dataCategoryPolicyId:action.payload
            }
        case GET_UNKER:
            return {
                ...state,
                dataUnker:action.payload
            }
        case GET_UNKER_ID:
            return {
                ...state,
                dataUnkerId:action.payload
            }
        case GET_POLICY_SEARCH:
            return {
                ...state,
                dataPolicySearch:action.payload
            }
        case GET_COUNTER_DOWNLOAD_POLICY:
            return {
                ...state,
                counterDownload:action.payload
            }
        case GET_COUNTER_VIEW_POLICY:
            return {
                ...state,
                counterView:action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default getCategoryPolicyReducer;